import { motion } from 'motion/react';
import styled, { css, keyframes } from 'styled-components';
import { pxToRem, themeGet } from 'modules/v2';
export const Divider = styled.div `
  width: ${pxToRem(1)};
  flex-shrink: 0;
  background-color: ${themeGet('colors.border.100')};
`;
export const FalconWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${themeGet('borderRadius.circle')};
  background-color: ${({ $state }) => $state === 'success' ? themeGet('colors.green.500') : themeGet('colors.red.500')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.gray.0')};
  }
`;
const getSizeStyle = (size) => {
    switch (size) {
        case 'sm':
            return css `
        height: ${pxToRem(22)};
        border-radius: ${pxToRem(11)};
        gap: ${themeGet('spacing.sm')};
        padding: ${themeGet('spacing.sm')} ${themeGet('spacing.md')};

        ${Divider} {
          height: ${pxToRem(11)};
        }

        ${FalconWrapper} {
          height: ${pxToRem(11)};
          width: ${pxToRem(11)};

          [data-icon='falcon'] {
            transform: scale(0.5);
          }
        }
      `;
        case 'md':
            return css `
        height: ${pxToRem(28)};
        border-radius: ${pxToRem(14)};
        gap: ${themeGet('spacing.md')};
        padding: ${themeGet('spacing.md')} ${themeGet('spacing.lg')};

        ${Divider} {
          height: ${pxToRem(14)};
        }

        ${FalconWrapper} {
          height: ${pxToRem(14)};
          width: ${pxToRem(14)};

          [data-icon='falcon'] {
            transform: scale(0.65);
          }
        }
      `;
        case 'lg':
            return css `
        height: ${pxToRem(36)};
        border-radius: ${pxToRem(18)};
        gap: ${themeGet('spacing.md')};
        padding: ${themeGet('spacing.lg')};

        ${Divider} {
          height: ${pxToRem(18)};
        }

        ${FalconWrapper} {
          height: ${pxToRem(18)};
          width: ${pxToRem(18)};

          [data-icon='falcon'] {
            transform: scale(0.8);
          }
        }
      `;
        default:
            return undefined;
    }
};
const sweepAnimation = keyframes `
  0% {
    transform: translateX(-150%);
  }
    
  100% {
    transform: translateX(250%);
  }
`;
export const Container = styled(motion.div).attrs(() => ({
    animate: {
        opacity: 1,
    },
    initial: {
        opacity: 0,
    },
    transition: {
        type: 'tween',
        ease: [0.25, 0.1, 0.25, 1],
        duration: 0.375,
    },
})) `
  ${(props) => getSizeStyle(props.$size)};

  border: solid ${pxToRem(1)} ${themeGet('colors.border.100')};

  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  overflow: hidden;
  white-space: nowrap;
  box-sizing: border-box;
  width: fit-content;

  &::before {
    content: '';
    position: absolute;
    z-index: 2;
    top: 0;
    bottom: 0;
    width: 80%;
    background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.7) 50%, transparent 100%);
    animation: ${sweepAnimation} 2s ease-in-out infinite;
    pointer-events: none;
    transition: opacity 250ms ease-out;
    opacity: ${({ $showAnimation }) => ($showAnimation ? 1 : 0)};
  }
`;
export const IconContainer = styled.div `
  flex-shrink: 0;
`;
